import { useState } from "react";

import { ArrowDropDown, ArrowDropUp, AddBox } from "@mui/icons-material";

export default function HiddenBlock(props) {
  const [hideBlock, setHideBlock] = useState(true);
  const toggleBlock = () => {
    setHideBlock((state) => !state);
  };

  return (
    <div className={props.className}>
      <h2 className="toggleLink" onClick={toggleBlock}>
        {props.title}
        {hideBlock ? <ArrowDropDown /> : <ArrowDropUp />}
      </h2>
      <div className={"claimed" + (hideBlock ? " hidden" : "")}>
        {props.children}
      </div>
    </div>
  );
}
